import * as React from 'react';
import Layout from '../components/layout/Layout';
import Mainpage from '../components/homepage/Mainpage';
import { SEO } from '../components/seo';



const Homepage = () => {
    return <>
        <Layout>
            <Mainpage/>
        </Layout>
    </>;
};

export default Homepage;

export const Head = () => (
  <SEO title="Best IELTS Online Coaching in India | IELTS Ninja" description="Join the Best IELTS Online Coaching to learn from certified tutors. Get your desired IELTS band in 30 days from India's Leading Online IELTS Coaching platform."/>
)






